
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mui-core-v5",
      function () {
        return require("private-next-pages/blog/mui-core-v5.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/mui-core-v5"])
      });
    }
  